// CocoBeauty Theme - Main JavaScript

document.addEventListener('DOMContentLoaded', function() {
  
  // Accordion functionality
  window.toggleAccordion = function(id) {
    const content = document.getElementById('accordion-content-' + id);
    const icon = document.getElementById('accordion-icon-' + id);
    
    if (content && icon) {
      content.classList.toggle('open');
      icon.classList.toggle('open');
    }
  };
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  // Intersection Observer for fade-in animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in-up');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  document.querySelectorAll('.observe-fade').forEach(el => {
    observer.observe(el);
  });
  
  // Random stock count update
  function updateStockCount() {
    const stockEl = document.getElementById('stock-count');
    if (stockEl) {
      const currentStock = parseInt(stockEl.textContent);
      if (currentStock > 10) {
        const newStock = currentStock - Math.floor(Math.random() * 2);
        stockEl.textContent = newStock;
      }
    }
  }
  
  // Update stock every 30-60 seconds
  setInterval(updateStockCount, 30000 + Math.random() * 30000);
  
  // Lazy loading images
  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.src = img.dataset.src;
    });
  } else {
    // Fallback for browsers that don't support lazy loading
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
    document.body.appendChild(script);
  }
  
  // Form validation helper
  window.validateEmail = function(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  
  // Add to cart notification
  window.showNotification = function(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 z-50 px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 translate-x-full ${
      type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
    }`;
    notification.textContent = message;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.remove('translate-x-full');
    }, 100);
    
    setTimeout(() => {
      notification.classList.add('translate-x-full');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  };
  
  // Mobile menu toggle (if needed)
  window.toggleMobileMenu = function() {
    const menu = document.getElementById('mobile-menu');
    if (menu) {
      menu.classList.toggle('hidden');
    }
  };
  
  // Quantity selector helper
  window.updateQuantity = function(action, inputId) {
    const input = document.getElementById(inputId);
    if (input) {
      let value = parseInt(input.value) || 1;
      if (action === 'increase') {
        value++;
      } else if (action === 'decrease' && value > 1) {
        value--;
      }
      input.value = value;
    }
  };
  
});

// Shopify Cart AJAX helper
window.CartAPI = {
  add: async function(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });
      const data = await response.json();
      if (response.ok) {
        window.showNotification('Added to cart!', 'success');
        return data;
      } else {
        throw new Error(data.message || 'Error adding to cart');
      }
    } catch (error) {
      window.showNotification(error.message, 'error');
      throw error;
    }
  },
  
  get: async function() {
    const response = await fetch('/cart.js');
    return response.json();
  },
  
  update: async function(updates) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates })
    });
    return response.json();
  },
  
  clear: async function() {
    const response = await fetch('/cart/clear.js', {
      method: 'POST'
    });
    return response.json();
  }
};
